import * as React from 'react';
import * as _ from 'lodash';
import { useDevicesData } from '../../data/DataProviders/DevicesDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { DataIndicators } from '../DataIndicators';
import { DeviceListItem } from '../DeviceListItem';
import { sortObjectArrayNaturally, compareNaturally } from '../../lib';
import { DeviceListGroups } from '../DeviceListGroups';
import { AppRoute } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { DeviceListData } from '../../types/device';

export const DeviceGroups: React.FC<{ deviceDetailAppRoute: AppRoute }> = (props) => {
    const devicesData = useDevicesData();
    const { t } = useLanguageLocale();
    const history = useHistory();

    const navigateToDeviceDetail = (deviceData: { id: string }): void => {
        if ('deviceId' in props.deviceDetailAppRoute) {
            pushAppRoute(history, {
                ...props.deviceDetailAppRoute,
                deviceId: deviceData.id,
            });
        }
    };

    const devices: DeviceListData[] = isDataLoaded(devicesData)
        ? sortObjectArrayNaturally(devicesData.value, [{ sortField: 'type' }])
        : [];

    const deviceGroups = isDataLoaded(devicesData)
        ? _.groupBy(devices, (d) => d.type || t('DASHBOARD.UNKNOWN_DEVICE_TYPE'))
        : {};

    const groups = Object.keys(deviceGroups)
        .sort(compareNaturally)
        .map((groupName) => ({
            name: groupName,
            items: deviceGroups[groupName],
        }));

    const isEmpty = isDataLoaded(devicesData) && devicesData.value.length === 0;

    return (
        <>
            <DataIndicators
                errorMessage={t('DASHBOARD.ERROR_LOADING_DEVICES')}
                emptyMessage={t('DASHBOARD.NO_DEVICES')}
                data={devicesData}
                emptyIcon="Devices"
                isEmpty={isEmpty}
            />

            <DeviceListGroups groups={groups} component={DeviceListItem} navigationFn={navigateToDeviceDetail} />
        </>
    );
};
